import { DELETE } from './../queryKeys';
import { userRolesApi } from "src/services/settings/userRoles"
import { useMutationBuilder, useQueryBuilder } from "../useBuilders"
import { CREATE, FETCH, UPDATE, USER_ROLES } from "../queryKeys";
import { UserRole } from 'src/types/settings/userRoles';

export const useFetchUserRolesForAccount = () => {
  return useQueryBuilder([USER_ROLES, FETCH], async () => {
    const data = await userRolesApi.fetchUserRolesForAccount();
    return data as UserRole[];
  })
}

export const useFetchUserRole = (id?: string) => {
  return useQueryBuilder(
    [USER_ROLES, id || "new"],
    async () => {
      if (!id || id === "new") return null;
      const data = await userRolesApi.fetchUserRoles(id);
      return data as UserRole;
    }
  );
};

export const useUpdateUserRole = () => {
  return useMutationBuilder<UserRole, { id: string; data: Partial<UserRole> }>(
    [USER_ROLES , UPDATE],
    ({ id, data }) => userRolesApi.updateUserRoles(id, data),
    [USER_ROLES]
  );
};

export const useCreateUserRole = () => {
  return useMutationBuilder<UserRole, Omit<UserRole, "id">>(
    [USER_ROLES , CREATE],
    (data) => userRolesApi.createUserRole(data),
    [USER_ROLES]
  );
}

export const useDeleteUserRole = () => {
  return useMutationBuilder<any, string>(
    [USER_ROLES , DELETE],
    (id) => userRolesApi.deleteUserRole(id),
    [USER_ROLES]
  );
}